exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#reservation-dialog.dialog {\n  flex-direction: column;\n}\n#user-autocomplete.mdc-menu.mdc-menu-surface {\n  position: unset;\n  width: 100%;\n}", ""]);

// exports
